export default __webpack_public_path__ + "static/media/icon-lesSoignants.1879a4b6.svg";